<template>
  <v-card class="pa-4">
    <v-card-title class="headline">Integraciones API (CRUD)</v-card-title>
    <v-card-text>
      <v-list>
        <v-list-group
          v-for="(entidad, idx) in crud" :key="idx"
          :value="false"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ entidad.nombre }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(ep, j) in entidad.endpoints" :key="j">
            <v-list-item-content>
              <v-list-item-title>
                <span class="font-weight-bold">{{ ep.metodo }}</span>
                <code>{{ ep.url }}</code>
              </v-list-item-title>
              <v-list-item-subtitle>{{ ep.descripcion }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ListaIntegraciones",
  data() {
    return {
      crud: [
        {
          nombre: "Clientes",
          endpoints: [
            { metodo: "GET", url: "/api/get-clientes", descripcion: "Listar clientes" },
            { metodo: "POST", url: "/api/save-cliente", descripcion: "Crear cliente" },
            { metodo: "GET", url: "/api/getcliente/{user_id}", descripcion: "Obtener cliente por ID" },
            { metodo: "POST", url: "/api/update-cliente", descripcion: "Actualizar cliente" },
            { metodo: "POST", url: "/api/delete-cliente", descripcion: "Eliminar cliente" },
          ]
        },
        {
          nombre: "Presupuestos",
          endpoints: [
            { metodo: "GET", url: "/api/get-presupuestos", descripcion: "Listar presupuestos" },
            { metodo: "POST", url: "/api/save-presupuesto", descripcion: "Crear presupuesto" },
            { metodo: "GET", url: "/api/getpresupuesto/{user_id}", descripcion: "Obtener presupuesto por ID" },
            { metodo: "POST", url: "/api/update-presupuesto", descripcion: "Actualizar presupuesto" },
            { metodo: "POST", url: "/api/delete-presupuesto", descripcion: "Eliminar presupuesto" },
          ]
        },
        {
          nombre: "Proveedores",
          endpoints: [
            { metodo: "GET", url: "/api/get-proveedores", descripcion: "Listar proveedores" },
            { metodo: "POST", url: "/api/save-proveedor", descripcion: "Crear proveedor" },
            { metodo: "GET", url: "/api/getproveedor/{id}", descripcion: "Obtener proveedor por ID" },
            { metodo: "POST", url: "/api/update-proveedor", descripcion: "Actualizar proveedor" },
            { metodo: "POST", url: "/api/delete-proveedor", descripcion: "Eliminar proveedor" },
          ]
        },
        {
          nombre: "Órdenes",
          endpoints: [
            { metodo: "GET", url: "/api/get-ordenes", descripcion: "Listar órdenes" },
            { metodo: "POST", url: "/api/save-orden", descripcion: "Crear/Actualizar orden" },
            { metodo: "GET", url: "/api/get-orden/{id}", descripcion: "Obtener orden por ID" },
            { metodo: "POST", url: "/api/save-orden", descripcion: "Actualizar orden" },
            { metodo: "GET", url: "/api/delete-orden/{id}", descripcion: "Eliminar orden" },
          ]
        },
      ]
    };
  }
};
</script>

<style scoped>
code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.95em;
}
</style> 